module.exports = __webpack_public_path__ + "media/images/niq-lock-da56095494299a87c5315472a225ebfa.svg";